import { useTranslation } from "react-i18next";

export function PrivacyRoute() {
  const { t } = useTranslation();
  return (
    <article className="mx-auto max-w-prose px-4 py-8 text-fg">
      <h1 className="text-3xl font-bold text-fg">{t("privacy.title")}</h1>
      <p className="mt-2 text-sm text-fg-mute">{t("privacy.updated")}</p>

      <section className="mt-8 space-y-4">
        <p>{t("privacy.intro")}</p>
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-semibold text-fg">{t("privacy.who.title")}</h2>
        <p className="mt-2">{t("privacy.who.body")}</p>
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-semibold text-fg">{t("privacy.data.title")}</h2>
        <ul className="mt-2 list-disc space-y-2 pl-6">
          <li>{t("privacy.data.location")}</li>
          <li>{t("privacy.data.device")}</li>
          <li>{t("privacy.data.account")}</li>
          <li>{t("privacy.data.content")}</li>
          <li>{t("privacy.data.analytics")}</li>
          <li>{t("privacy.data.crash")}</li>
        </ul>
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-semibold text-fg">{t("privacy.uses.title")}</h2>
        <ul className="mt-2 list-disc space-y-2 pl-6">
          <li>{t("privacy.uses.show")}</li>
          <li>{t("privacy.uses.rate")}</li>
          <li>{t("privacy.uses.improve")}</li>
          <li>{t("privacy.uses.safety")}</li>
        </ul>
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-semibold text-fg">{t("privacy.share.title")}</h2>
        <p className="mt-2">{t("privacy.share.body")}</p>
        <ul className="mt-2 list-disc space-y-2 pl-6">
          <li>{t("privacy.share.supabase")}</li>
          <li>{t("privacy.share.mapbox")}</li>
          <li>{t("privacy.share.sentry")}</li>
          <li>{t("privacy.share.posthog")}</li>
          <li>{t("privacy.share.turnstile")}</li>
        </ul>
        <p className="mt-2">{t("privacy.share.nosale")}</p>
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-semibold text-fg">{t("privacy.retention.title")}</h2>
        <p className="mt-2">{t("privacy.retention.body")}</p>
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-semibold text-fg">{t("privacy.rights.title")}</h2>
        <p className="mt-2">{t("privacy.rights.body")}</p>
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-semibold text-fg">{t("privacy.children.title")}</h2>
        <p className="mt-2">{t("privacy.children.body")}</p>
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-semibold text-fg">{t("privacy.changes.title")}</h2>
        <p className="mt-2">{t("privacy.changes.body")}</p>
      </section>

      <section className="mt-8">
        <h2 className="text-xl font-semibold text-fg">{t("privacy.contact.title")}</h2>
        <p className="mt-2">{t("privacy.contact.body")}</p>
      </section>
    </article>
  );
}
